import { FC, useCallback, useMemo, useState } from 'react';
import { Field, Form as CoreForm, FormErrorBoundary, IFormProps as ICoreFormProps} from '@ngt/forms-core';
import { Box, Button, Collapse } from '@mui/material';
import FormValue from './state/FormValue';
import FormDirty from './state/FormDirty';
import FormState from './state/FormState';
import FormFields from './state/FormFields';
import FormInitialValue from './state/FormInitialValue';
import FormTouched from './state/FormTouched';
import FormFocused from './state/FormFocused';
import FormErrors from './state/FormErrors';
import CollapsiblePanel from '@/components/layouts/CollapsiblePanel';
import { FormError } from '@/errors';

export interface IFormProps<TFormValue extends object> extends ICoreFormProps<TFormValue, FormError> {
    debug?: boolean;
}

const defaultValue = {};

const Form = <TFormValue extends object>({
    debug,
    children,
    initialValue,
    ...coreFormProps
}: IFormProps<TFormValue>) => {
    return (
        <CoreForm
            {...coreFormProps}
            initialValue={initialValue ?? defaultValue as TFormValue}
        >
            <FormErrorBoundary>
                <Field propertyPath="" />
                {children}
                {
                    debug && (
                        <CollapsiblePanel 
                            ComponentProps={{
                                title: 'Debug'
                            }}
                        >
                            <Box sx={{pl: 4}}>
                                <FormState />
                                <FormFields />
                                <FormInitialValue />
                                <FormValue />
                                <FormTouched />
                                <FormDirty />
                                <FormFocused />
                                <FormErrors />
                            </Box>
                        </CollapsiblePanel>
                    )
                }                      
            </FormErrorBoundary>
        </CoreForm>
    )
};

export default Form;